import authentication from "@irati/auth"
import env from "@irati/utils/env"
import {PRODUCTION} from "@irati/utils/constants/environment"

export function getDealUrl(dealUrlSlug: string) {
  const subdomain = authentication.business().subdomain
  const path = `perks/info/${dealUrlSlug}`
  const tld = env.ENVIRONMENT_NAME === PRODUCTION ? "com" : "net"
  const utmSource = "perks"
  return `https://${subdomain}.perkbox.${tld}/${path}?utm_source=${utmSource}&utm_medium=share_link`
}
